import { caching } from '@/common/cache.dict.js';
import { boundApiRequest } from '@/restapi/restapi.base.js';

const doRequest = boundApiRequest('/api/documentType/');


async function _documentTypeDict() {
    const { result } = await doRequest('all');
    return result;
}

export const documentTypeDict = caching(_documentTypeDict);
